import React, { useContext } from "react";
import { AppContext } from "../../pages/Home";
import parse from "html-react-parser";
import { RightCheckedFilled } from "../../icons";

const Banner = () => {

    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const date = new Date();
    const currentMonth = monthNames[date.getMonth()];
    const currentYear = new Date().getFullYear();

    const { pageContent } = useContext(AppContext);
    
    return (
        <div className="min-h-full flex flex-col bg-[#f8fafd]">
            <div className="flex-1">
                <div className="main-wrapper">
                    <div className="w-full bg-[#f8fafd]">
                        <div className="max-w-[1042px] mx-auto p-4 md:px-5 md:py-10  overflow-hidden">
                                <div className="max-w-[936px]">
                                    <h1 className="banner-heading font-lexendSemibold text-[22px] md:text-4xl leading-[30px] md:leading-[48px] text-secondary-500 font-semibold">
                                        {pageContent?.heading ? parse(pageContent?.heading) : parse(`Top <span>Accredited Online Colleges</span> of`)} <div className="inline-block"> {currentMonth} {currentYear}</div>
                                    </h1>
                                    
                                    <h2 className="hidden md:block mt-4 font-lexendlight text-lg text-dark-500">
                                        {pageContent?.sub_heading ? parse(pageContent?.sub_heading) : `Our curated list of colleges offering affordable online degrees.`}
                                    </h2>
                                    
                                </div>
                        </div>
                    </div>

                    <div className="hidden md:block bg-light-500 border-b border-light-600">
                        <div className="flex max-w-[1042px] mx-auto py-3 px-4">
                            <span className="mr-2"><RightCheckedFilled /></span>
                            <div className="font-lexendlight text-sm text-dark-500 font-light"> Last Updated {currentMonth} {currentYear}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
